import { render, staticRenderFns } from "./yield.vue?vue&type=template&id=4acdfffe&scoped=true&"
import script from "./yield.vue?vue&type=script&lang=js&"
export * from "./yield.vue?vue&type=script&lang=js&"
import style0 from "./yield.vue?vue&type=style&index=0&id=4acdfffe&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4acdfffe",
  null
  
)

export default component.exports